import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  PaymentActionsComponent,
  PaymentDateFormComponent,
  PaymentStatusFormComponent,
} from '@techspert-io/payments';
import { BtxSharedModule } from '../../shared/btx-shared.module';
import { PaymentMethodPipe } from '../../shared/pipes/payment-method.pipe';
import { PaymentStatusPipe } from '../../shared/pipes/payment-status.pipe';
import { NotesDialogComponent } from './notes-dialog/notes-dialog.component';
import { PaymentsComponent } from './payments.component';

@NgModule({
  imports: [
    CommonModule,
    BtxSharedModule,
    RouterModule,
    PaymentMethodPipe,
    PaymentStatusPipe,
    PaymentActionsComponent,
    PaymentDateFormComponent,
    PaymentStatusFormComponent,
  ],
  declarations: [PaymentsComponent, NotesDialogComponent],
})
export class PaymentsModule {}
